import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../core/pagination/datatable";
// import Swal from 'sweetalert2';
import {
  // Calendar,
  ChevronUp,
  Filter,
  PlusCircle,
  RotateCcw,
  Sliders,
  // Zap,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
// import { DatePicker } from "antd";
import AddVariant from "../../core/modals/inventory/addvariant";
// import EditVarient from "../../core/modals/inventory/editvarient";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { setToogleHeader } from "../../core/redux/action";
// import withReactContent from 'sweetalert2-react-content';
import Axios from "axios";
import { API_BASE_URL, GET_VARIANT } from "../../Config";
import { setvariantattributes_data } from "../../core/redux/action";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getUserPermissions } from "../../UserPermissions";
import SpinLoader from "../loader/SpinLoader";

const VariantAttributes = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  // const [brandsData, setBrandsData] = useState([]);
  // const [editVariantObj, setEditVariantObj] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    // const brandsData = JSON.parse(sessionStorage.getItem('filteredDDLData_BRAND'));
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      // setBrandsData(brandsData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const dataSource = useSelector((state) => state.variantattributes_data);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(`${API_BASE_URL}${GET_VARIANT}?OrgId=/${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status) {
            dispatch(setvariantattributes_data(response.data.ResultData));
            setLoading(false);
            console.log("Data fetched successfully:");
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Categories");
    setPermissions(perms);
  }, []);

  // const [selectedDate, setSelectedDate] = useState(new Date());
  // const handleDateChange = (date) => {
  //   setSelectedDate(date);
  // };
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const oldandlatestvalue = [
    { value: "date", label: "Sort by Date" },
    { value: "newest", label: "Newest" },
    { value: "oldest", label: "Oldest" },
  ];

  const renderWithNA = (value) =>
    value === null || value === "NULL" ? "N/A" : value;

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.length - b.Name.length,
      render: renderWithNA,
    },

    {
      title: "Values",
      dataIndex: "Value",
      sorter: (a, b) => a.Value.length - b.Value.length,
      render: renderWithNA,
    },

    {
      title: "Status",
      dataIndex: "Isactive",
      render: (Isactive) => (
        <span
          className={`badge badge-${
            Isactive === true ? "linesuccess" : "linedanger"
          }`}
        >
          {Isactive === true ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a, b) => (a.IsActive ? 1 : -1) - (b.IsActive ? 1 : -1),
    },

    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a, b) => a.Description.length - b.Description.length,
      render: renderWithNA,
    },

    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   key: "actions",
    //   render: (test, record) => (
    //     <div className="action-table-data">
    //       <div className="edit-delete-action">
    //         <Link
    //           className="me-2 p-2"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit-variant"
    //           onClick={() => showEditModal(record)}
    //         >
    //           <i data-feather="edit" className="feather-edit"></i>
    //         </Link>
    //         <Link className="confirm-text p-2" to="#" onClick={showConfirmationAlert}>
    //           <i data-feather="trash-2" className="feather-trash-2"></i>
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // },
  ];

  // const showEditModal = (variantObj) => {
  //   setEditVariantObj(variantObj); // Update the state with the ID of the category to edit
  // };

  const filteredData = dataSource.filter(
    (item) =>
      (item && // Check if item is defined
        item.Name &&
        item.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.Description &&
        item.Description.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = dataSource.map((item) => ({
      "Variant Name": item.Name,
      Value: item.Value,
      Dscription: item.Description,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "VariantsData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "VariantsData.xlsx");
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Attendance Report",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = ["Name", "Value", "Description"];
    tableData.push(headers);

    // Add rows
    dataSource.forEach((item) => {
      const row = [];
      row.push(item.Name, item.Value, item.Description);
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("VariantsData.pdf");
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Variant Attributes</h4>
              <h6>Manage your variant attributes</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li className={`${permissions.isExport}`}>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link onClick={generatePDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li className={`${permissions.isExport}`}>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={handleDownloadExcel}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <i data-feather="printer" className="feather-printer" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <a
              to="#"
              className={`btn btn-added ${permissions.isRead}`}
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightVTAdd"
              aria-controls="offcanvasRightVTAdd"
            >
              <PlusCircle className="me-2" />
              Add New Variant
            </a>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort">
                <Sliders className="info-img" />
                <Select
                  className="select"
                  options={oldandlatestvalue}
                  placeholder="Newest"
                />
              </div>
            </div>
            {/* /Filter */}

            {/* /Filter */}
            <div className="table-responsive">
              {loading ? (
                <SpinLoader />
              ) : (
                <Table columns={columns} dataSource={filteredData} />
              )}
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <AddVariant />
      {/* <EditVarient variantObj={editVariantObj} /> */}
    </div>
  );
};

export default VariantAttributes;
